const hybrid = {}
// 把vue中绑定的对象挂载到window上
window.Hybrid = hybrid;
// 导出共给vue组件中引入使用
export default hybrid


// WEBPACK FOOTER //
// ./src/common/hybrid.js